<template>
  <v-container fluid pa-0 bm-form-element-row>
    <v-layout>
      <v-flex xs12 :class="{ md8: !fullWidth }">
        <slot
          :on="generateEventListeners()"
          :t="t || undefined"
          :tooltip="isTwoColumnView && hintTextOrTooltip ? '' : undefined"
        ></slot>
      </v-flex>
    </v-layout>
    <div v-if="isTwoColumnView" class="bm-column-hint">
      <bm-column-hint
        :active-field="isHintActive"
        :empty="!hintTextOrTooltip || hintTextOrTooltip.length === 0"
      >
        {{ hintTextOrTooltip }}
      </bm-column-hint>
    </div>
  </v-container>
</template>

<script lang="ts">
import BmColumnHint from "@/components/controls/wizard/BmColumnHint.vue";
import type { PropType } from "vue";
import { defineComponent } from "vue";
import Guid from "@/app/types/common/guid";
import wizardStore from "@/store/modules/wizardStore";
import Key from "@/app/types/common/key";
import { translate } from "@/plugins/i18n";
export default defineComponent({
  name: "BmWizardFormElement",
  components: { BmColumnHint },
  props: {
    hintText: {
      type: String,
      default: "",
    },
    t: {
      type: Object as PropType<string | Key>,
      default: undefined,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hintId: Guid.create(),
    };
  },
  computed: {
    hintTextOrTooltip(): string | undefined {
      return (
        this.hintText ||
        translate(Key.fromString(`${this.t}_hint`)) ||
        undefined
      );
    },
    isTwoColumnView(): boolean {
      return this.$vuetify.breakpoint.mdAndUp && !this.fullWidth;
    },
    isHintActive(): any {
      return wizardStore.state.activeHint?.equals(this.hintId);
    },
  },
  methods: {
    generateEventListeners(): {} {
      return {
        focus: (event: FocusEvent) => {
          if (this.hintTextOrTooltip) {
            wizardStore.pushHint(this.hintId);
          }
        },
        blur: (event: FocusEvent) => {
          if (this.hintTextOrTooltip) {
            wizardStore.popHint(this.hintId);
          }
        },
      };
    },
  },
});
</script>

<style scoped lang="sass">
.bm-form-element-row
  position: relative

div.bm-column-hint
  position: absolute
  left: 66.666666%
  z-index: 2
  top: 0
</style>
